<template>
  <li
    v-if="item"
    class="tree-item"
  >
    <div class="item-title">
      <button
        :class="{ 'expand-button': true, 'show': hasChildren }"
        role="button"
        @click="toggleExpand"
      >
        <md-icon>
          {{ expanded ? "expand_more" : "expand_less" }}
        </md-icon>
      </button>
  
      <button
        :class="clsx('tree-button', { highlighted: item.isHighlighted })"
        role="button"
        :title="item[label]"
        :disabled="item.isDisabled"
        @click="$emit('click', item)"
      >
        {{ item[label] }}
      </button>
    </div>

    <ul v-if="hasChildren && expanded">
      <tree-item
        v-for="(child, i) in item.children"
        :key="`child-${i}}`"
        :item="child"
        :label="label"
        @click="$emit('click', $event)"
      />
    </ul>
  </li>
</template>

<script>
import clsx from "clsx";

export default {
  name: "TreeItem",
  props: {
    item: {
      type: Object,
      default: () => null,
    },
    label: {
      type: String,
      default: () => "label",
    },
  },
  data: () => ({
    internalExpanded: null,
  }),
  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0;
    },
    expanded() {
      return this.internalExpanded === null
        ? this.item.isExpanded
        : this.internalExpanded;
    }
  },
  methods: {
    toggleExpand() {
      this.internalExpanded = !this.expanded;
    },
    clsx,
  },
};
</script>

<style scoped lang="scss">
@mixin reset-button {
  border: none;
  background: transparent;
  cursor: pointer;
} 

ul {
  list-style: none;
  margin: 0;
  padding-left: 40px;
}

.tree-item {
  list-style: none;

  display: flex;
  flex-direction: column;
}

.item-title {
  display: flex;
  flex-direction: row;
}

.tree-button {
  @include reset-button;

  white-space: nowrap;
  padding: 0.5rem;

  &:disabled {
    opacity: 0.8;
    cursor: unset;
    color: unset;
  }

  &.highlighted {
    font-weight: bold;
  }
}

.expand-button {
  @include reset-button;

  padding: 0.25rem;
  opacity: 0;
  pointer-events: none;

  &.show {
    pointer-events: unset;
    opacity: unset;
  }
}

</style>
